export default __webpack_public_path__ + "static/media/14.08eab65c.svg";